(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gd-artwork-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gd-artwork-gallery')) {
  customElements.define('gd-artwork-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.views = [...this.querySelectorAll('[data-gallery-view]')];
      this.base = this.querySelector('[data-base]');
      this.dialog = this.querySelector('[data-gallery-dialog]');
      this.zoomContent = this.querySelector('[data-gallery-zoom-content]');
      this.zoomEvents = new AbortController();
      const zoomOptions = {signal: this.zoomEvents.signal};
      this.querySelectorAll('[data-gallery-zoom]').forEach(button => button.addEventListener('click', () => this.openZoom(button), zoomOptions));
      this.querySelector('[data-gallery-close]').addEventListener('click', () => this.closeZoom(), zoomOptions);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.closeZoom(); }, zoomOptions);
      this.dialog.addEventListener('close', () => this.restoreZoom(), zoomOptions);
      this.sceneButton = this.querySelector('[data-gallery-scene]');
      this.toggleScene = () => this.show(this.scene?.hidden ? this.scene : this.frameView || this.base);
      this.sceneButton.addEventListener('click', this.toggleScene);
      this.resetOnArrival = () => this.show(this.base, false);
      window.addEventListener('pageshow', this.resetOnArrival);
      this.show(this.base, false);
    }
    disconnectedCallback() {
      this.closeZoom();
      this.zoomEvents?.abort();
      window.removeEventListener('pageshow', this.resetOnArrival);
      this.sceneButton?.removeEventListener('click', this.toggleScene);
      this.ready = false;
    }
    openZoom(button) {
      if (this.dialog.open) return;
      const image = button.querySelector('img').cloneNode();
      image.className = 'gd-pilot-gallery__zoom-image';
      image.src = button.dataset.fullSrc;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.loading = 'eager';
      this.zoomContent.replaceChildren(image);
      this.zoomTrigger = button;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.zoomActive = true;
    }
    closeZoom() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreZoom();
    }
    restoreZoom() {
      if (!this.zoomActive) return;
      document.documentElement.style.overflow = this.previousOverflow;
      this.zoomActive = false;
      this.zoomTrigger?.focus({preventScroll: true});
    }
    setSelection({edition, imageId, frame, interaction}) {
      if (!this.ready) this.connectedCallback();
      const unframed = frame === 'none';
      this.frameView = unframed ? this.base : this.views.find(view => view.dataset.edition === edition && view.dataset.imageId === imageId);
      this.scene = !unframed && this.views.find(view => view.dataset.edition === edition && view.dataset.sceneFrame && view.dataset.sceneFrame === frame);
      this.sceneButton.hidden = !this.scene;
      this.show(interaction === 'frame' ? this.frameView || this.base : this.base, Boolean(interaction));
    }
    show(selected, announce = true) {
      if (!selected) return;
      this.views.forEach(view => { view.hidden = view !== selected; });
      const inRoom = selected === this.scene;
      this.sceneButton.setAttribute('aria-pressed', String(inRoom));
      this.sceneButton.textContent = inRoom ? this.sceneButton.dataset.hideLabel : this.sceneButton.dataset.showLabel;
      this.querySelector('[data-gallery-announcement]').textContent = announce ? selected.querySelector('figcaption').textContent : '';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gd-availability-request"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('gd-availability-request')){
  customElements.define('gd-availability-request',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.dialog=this.querySelector('dialog');
      this.querySelector('[data-availability-close]').addEventListener('click',()=>this.dialog.close(),options);
      this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||'';this.trigger?.focus({preventScroll:true});},options);
      if(this.querySelector('[data-availability-result]'))this.open();
    }
    open(trigger){
      if(this.dialog.open)return;
      this.trigger=trigger;
      this.previousOverflow=document.documentElement.style.overflow;
      this.dialog.showModal();document.documentElement.style.overflow='hidden';
      if(!this.querySelector('[data-availability-result]'))this.querySelector('input[type=email]')?.focus({preventScroll:true});
    }
    disconnectedCallback(){
      if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.previousOverflow||'';}
      this.abort?.abort();this.abort=null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gd-edition-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gd-edition-picker')) {
  customElements.define('gd-edition-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-edition-data]').textContent);
      this.edition = this.data.initial;
      this.pilot = Boolean(this.closest('.gd-artwork-page')?.querySelector('gd-artwork-gallery'));
      this.choices = {paper: {framed: false, color: 'black'}, canvas: {framed: false, color: 'black'}};
      const initial = this.data.offers[this.edition].find(v => v.id === this.data.initialId);
      if (!this.pilot && initial && this.edition !== 'original' && ['black', 'white', 'wood'].includes(initial.frame)) {
        this.choices[this.edition] = {framed: true, color: initial.frame};
      }
      this.querySelectorAll('[data-edition]').forEach(button => button.addEventListener('click', () => {
        this.edition = button.dataset.edition;
        if (this.pilot && this.edition !== 'original') this.choices[this.edition] = {framed: false, color: 'black'};
        this.render('edition');
      }));
      this.querySelectorAll('[data-framed]').forEach(button => button.addEventListener('click', () => {
        if (this.edition === 'original') return;
        const framed = button.dataset.framed === 'true';
        if (this.pilot && framed && !this.choices[this.edition].framed) this.choices[this.edition].color = 'black';
        this.choices[this.edition].framed = framed;
        this.render('frame');
      }));
      this.querySelectorAll('[data-color]').forEach(button => button.addEventListener('click', () => {
        if (this.edition === 'original') return;
        this.choices[this.edition].color = button.dataset.color;
        this.render('frame');
      }));
      this.querySelector('form').addEventListener('submit', event => {
        const variant = this.selectedVariant();
        if (!variant || !variant.available || this.querySelector('[data-variant]').value !== variant.id) {
          event.preventDefault();
          this.render();
          return;
        }
        if (this.edition === 'original') this.querySelector('[data-quantity]').value = '1';
      });
      this.render();
    }
    selectedVariant() {
      const choice = this.choices[this.edition];
      const frame = this.edition === 'original' || !choice.framed ? 'none' : choice.color;
      return this.data.offers[this.edition].find(variant => variant.frame === frame);
    }
    render(interaction = null) {
      const original = this.edition === 'original';
      const choice = this.choices[this.edition];
      const variant = this.selectedVariant();
      const labels = this.data.labels;
      const pending = !variant || !variant.id;
      const available = Boolean(!pending && variant.available);
      this.querySelectorAll('[data-edition]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.edition === this.edition)));
      this.querySelector('[data-frame-group]').hidden = original;
      this.querySelector('[data-color-group]').hidden = original || !choice.framed;
      this.querySelector('[data-framed-label]').textContent = this.edition === 'canvas' ? labels.floater : labels.framed;
      if (!original) {
        this.querySelectorAll('[data-framed]').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.framed === 'true') === choice.framed)));
        this.querySelectorAll('[data-color]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === choice.color)));
      }
      this.querySelector('[data-size]').textContent = this.data.sizes[this.edition] || '—';
      this.querySelector('[data-price]').textContent = variant ? variant.price : labels.soon;
      this.querySelector('[data-offer-note]').textContent = original ? labels.unique : labels[this.edition];
      this.querySelector('[data-status]').textContent = pending ? labels.pending : available ? (original ? labels.available : '') : original ? labels.sold : labels.unavailable;
      const idInput = this.querySelector('[data-variant]');
      idInput.value = available ? variant.id : '';
      idInput.disabled = !available;
      const quantity = this.querySelector('[data-quantity]');
      quantity.min = String(original ? 1 : variant?.min || 1);
      quantity.step = String(original ? 1 : variant?.step || 1);
      quantity.value = quantity.min;
      if (original || variant?.max) quantity.max = String(original ? 1 : variant.max);
      else quantity.removeAttribute('max');
      this.querySelector('[data-quantity-label]').hidden = original || !available;
      const buy = this.querySelector('[data-buy]');
      buy.disabled = !available;
      buy.textContent = pending ? labels.soon : available ? labels.add : original ? labels.sold : labels.unavailable;
      const gallery = this.closest('.gd-artwork-page')?.querySelector('gd-artwork-gallery');
      if (gallery) {
        const selection = {edition: this.edition, variantId: variant?.id, imageId: variant?.imageId, frame: variant?.frame, interaction};
        customElements.whenDefined('gd-artwork-gallery').then(() => gallery.setSelection(selection));
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gd-emily-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gd-emily-gallery')) {
  customElements.define('gd-emily-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.views = [...this.querySelectorAll('[data-view]')];
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.index = 0;
      this.paused = false;
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-next]').addEventListener('click',()=>{if(!this.swiped)this.go(this.index+1,true);},options);
      this.querySelector('[data-previous]').addEventListener('click',()=>{if(!this.swiped)this.go(this.index-1,true);},options);
      this.dots.forEach(button=>button.addEventListener('click',()=>this.go(Number(button.dataset.go),true),options));
      this.querySelector('[data-pause]').addEventListener('click',()=>{this.paused=!this.paused;this.playState();},options);
      this.addEventListener('keydown',event=>{if(this.dialog.open)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1),true);}},options);
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),options);
      this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||'';this.zoomTrigger?.focus({preventScroll:true});this.playState();},options);
      this.querySelectorAll('[data-zoom]').forEach(button=>button.addEventListener('click',()=>{
        if(this.swiped)return;
        this.zoomTrigger=button;
        const img=button.querySelector('img').cloneNode();
        img.src=button.dataset.fullSrc;img.removeAttribute('srcset');img.removeAttribute('sizes');img.loading='eager';
        img.addEventListener('click',()=>img.classList.toggle('is-zoomed'),options);
        this.querySelector('[data-zoom-content]').replaceChildren(img);
        this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.dialog.showModal();this.playState();
      },options));
      this.querySelector('.gd-emily-gallery__stage').addEventListener('pointerdown',event=>{this.swiped=false;this.startX=event.clientX;this.startY=event.clientY;},options);
      this.querySelector('.gd-emily-gallery__stage').addEventListener('pointerup',event=>{const dx=event.clientX-this.startX,dy=event.clientY-this.startY;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)){this.swiped=true;this.go(this.index+(dx<0?1:-1),true);}},options);
      this.addEventListener('focusin',event=>{if(event.target.matches(':focus-visible'))clearInterval(this.timer);},options);
      this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget))this.playState();},options);
      document.addEventListener('visibilitychange',()=>this.playState(),options);
      this.playState();
    }
    go(index,manual=false){
      this.index=(index+this.views.length)%this.views.length;
      this.views.forEach((view,i)=>{const active=i===this.index;view.classList.toggle('is-active',active);view.inert=!active;view.setAttribute('aria-hidden',String(!active));});
      this.dots.forEach((button,i)=>button.setAttribute('aria-current',String(i===this.index)));
      const caption=this.views[this.index].querySelector('figcaption').textContent;
      this.querySelector('[data-caption]').textContent=caption;
      if(manual){this.querySelector('[data-announcement]').textContent=caption;this.playState();}
    }
    playState(){
      clearInterval(this.timer);
      const button=this.querySelector('[data-pause]');
      button.setAttribute('aria-label',this.paused?button.dataset.play:button.dataset.stop);
      button.querySelector('span').textContent=this.paused?'▶':'Ⅱ';
      if(!this.paused&&!document.hidden&&!this.dialog.open)this.timer=setInterval(()=>this.go(this.index+1),Math.min(3000,Number(this.dataset.delay)||3000));
    }
    disconnectedCallback(){clearInterval(this.timer);if(this.dialog?.open)this.dialog.close();this.abort?.abort();this.abort=null;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gd-emily-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gd-emily-picker')) {
  customElements.define('gd-emily-picker', class extends HTMLElement {
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.data=JSON.parse(this.querySelector('[data-edition-data]').textContent);
      this.edition=this.data.initial;
      this.choices={paper:{framed:false,color:'black',size:''},canvas:{framed:false,color:'black'}};
      const normalize=s=>(s||'').toLowerCase().replace(/×/g,'x').replace(/cm/g,'').replace(/\s/g,'');
      const paperDefault=this.data.offers.paper.find(v=>normalize(v.size)===normalize(this.data.sizes.original))||this.data.offers.paper.find(v=>normalize(v.size)===normalize(this.data.sizes.paper))||this.data.offers.paper[0];
      this.choices.paper.size=paperDefault?.size||'';
      const initial=this.data.offers[this.edition].find(v=>v.id===this.data.initialId);
      if(this.edition==='paper'&&initial)this.choices.paper.size=initial.size;
      if(this.edition!=='original'&&initial&&['black','white','wood'].includes(initial.frame))Object.assign(this.choices[this.edition],{framed:true,color:initial.frame});
      this.querySelector('[data-paper-size]').addEventListener('change',event=>{this.choices.paper.size=event.target.value;this.render();},options);
      this.querySelectorAll('[data-edition]').forEach(button=>button.addEventListener('click',()=>{if(button.disabled)return;this.edition=button.dataset.edition;this.render();if(this.notificationEdition())this.openAvailability(button);},options));
      this.querySelectorAll('[data-framed]').forEach(button=>button.addEventListener('click',()=>{if(this.edition==='original')return;this.choices[this.edition].framed=button.dataset.framed==='true';this.render();},options));
      this.querySelectorAll('[data-color]').forEach(button=>button.addEventListener('click',()=>{if(this.edition==='original')return;this.choices[this.edition].color=button.dataset.color;this.render();},options));
      this.querySelector('[data-buy]').addEventListener('click',()=>{if(this.notificationEdition())this.openAvailability(this.querySelector('[data-buy]'));},options);
      this.querySelector('form').addEventListener('submit',event=>{const v=this.selectedVariant();if(this.notificationEdition()||!v?.available||!v.id||this.querySelector('[data-variant]').value!==v.id){event.preventDefault();this.render();}else if(this.edition==='original')this.querySelector('[data-quantity]').value='1';},options);
      this.render();
    }
    notificationEdition(){return (this.edition==='original'&&this.data.exhibition)||(this.edition==='canvas'&&this.data.canvasPaused);}
    openAvailability(trigger){this.querySelector('gd-availability-request[data-availability-edition="'+this.edition+'"]')?.open(trigger);}
    selectedVariant(){const choice=this.choices[this.edition];const frame=this.edition==='original'||!choice.framed?'none':choice.color;return this.data.offers[this.edition].find(v=>v.frame===frame&&(this.edition!=='paper'||v.size===choice.size));}
    render(){
      const original=this.edition==='original',exhibition=original&&this.data.exhibition,choice=this.choices[this.edition],variant=this.selectedVariant(),paused=this.edition==='canvas'&&this.data.canvasPaused,notify=exhibition||paused,available=Boolean(variant?.id&&variant.available&&!notify),labels=this.data.labels;
      this.querySelectorAll('[data-delivery]').forEach(note=>{const visible=available&&note.dataset.delivery===(original?'original':'print');note.classList.toggle('is-visible',visible);note.setAttribute('aria-hidden',String(!visible));});
      this.querySelectorAll('[data-edition]').forEach(button=>button.setAttribute('aria-pressed',String(!button.disabled&&button.dataset.edition===this.edition)));
      const options=this.querySelector('[data-options]');options.classList.toggle('is-visible',!original&&!paused);options.inert=original||paused;
      const sizeRow=this.querySelector('[data-size-row]'),sizeSelect=this.querySelector('[data-paper-size]'),showSize=this.edition==='paper'&&sizeSelect.options.length>1;
      sizeRow.classList.toggle('is-visible',showSize);sizeRow.setAttribute('aria-hidden',String(!showSize));sizeSelect.disabled=!showSize;sizeSelect.value=this.choices.paper.size;
      const colors=this.querySelector('[data-colors]');const showColors=!original&&choice.framed;colors.classList.toggle('is-visible',showColors);colors.inert=!showColors;
      this.querySelectorAll('[data-finish-preview]').forEach(preview=>{const selected=!original&&!choice.framed&&preview.dataset.finishPreview===this.edition;preview.classList.toggle('is-visible',selected);preview.setAttribute('aria-hidden',String(!selected));});
      this.querySelector('[data-framed-label]').textContent=this.edition==='canvas'?labels.floater:labels.framed;
      this.querySelectorAll('[data-quality-text]').forEach(text=>{const selected=text.dataset.qualityText===this.edition;text.classList.toggle('is-visible',selected);text.setAttribute('aria-hidden',String(!selected));});
      if(!original){
        this.querySelectorAll('[data-framed]').forEach(button=>button.setAttribute('aria-pressed',String((button.dataset.framed==='true')===choice.framed)));
        this.querySelectorAll('[data-color]').forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.color===choice.color));const img=button.querySelector('img');const src=this.edition==='paper'?img.dataset.paperSrc:img.dataset.canvasSrc;if(img.getAttribute('src')!==src)img.src=src;});
      }
      this.querySelector('[data-price]').textContent=variant?.price||labels.soon;
      let selection=this.querySelector('[data-edition="'+this.edition+'"] .gd-emily-picker__edition-label').childNodes[0].textContent.trim();
      const selectedSize=this.edition==='paper'?variant?.size:this.data.sizes[this.edition];
      if(!original&&selectedSize)selection+=' · '+selectedSize.replace(/ x /g,' × ');
      if(!original&&choice.framed)selection+=' · '+this.querySelector('[data-color="'+choice.color+'"] span').textContent;
      if(exhibition)selection+=' · '+labels.exhibition;
      if(paused)selection+=' · '+labels.canvasPaused;
      this.querySelector('[data-selection]').textContent=selection;
      const note=this.querySelector('[data-exhibition-note]');if(note)note.hidden=!exhibition;
      const pausedNote=this.querySelector('[data-canvas-paused-note]');if(pausedNote)pausedNote.hidden=!paused;
      const id=this.querySelector('[data-variant]');id.disabled=!available;id.value=available?variant.id:'';
      const qty=this.querySelector('[data-quantity]');qty.min=String(original?1:variant?.min||1);qty.step=String(original?1:variant?.step||1);if(original||variant?.max)qty.max=String(original?1:variant.max);else qty.removeAttribute('max');qty.value=qty.min;
      this.querySelector('[data-quantity-label]').style.visibility=original||!available?'hidden':'visible';
      const buy=this.querySelector('[data-buy]');buy.disabled=!available&&!notify;buy.type=notify?'button':'submit';buy.classList.toggle('is-exhibition',exhibition);
      buy.querySelector('[data-buy-label]').textContent=paused?labels.canvasNotify:exhibition?labels.exhibition:available?labels.add:original?labels.sold:labels.unavailable;
      buy.querySelector('[data-buy-notify]').hidden=!exhibition;
      if(notify){buy.setAttribute('aria-haspopup','dialog');buy.setAttribute('aria-label',paused?labels.canvasNotifyLabel:labels.notifyLabel);}else{buy.removeAttribute('aria-haspopup');buy.removeAttribute('aria-label');}
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;}
  });
}
  } catch(e) { console.error(e); }
})();

})();
